import { memo, useMemo } from 'react'
import PropTypes from 'prop-types'

import { LinearProgress, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'

import { useSelector } from '@tabeeb/store'
import { useSharedContentLinks } from '@tabeeb/modules/contentSharedLinks/hooks/useSharedContentLink'
import SharedContentLinkSettings from '@tabeeb/modules/contentSharedLinks/components/SharedContentLinkSettings'
import { getIsCurrentUserOwner } from '../../../../users/selectors'
import VideoBridgeRegions from './VideoBridgeRegions'
import MuteChatNotifications from './MuteChatNotifications'

import useStyles from './styles'

const SessionSettingsDialog = ({ open, onClose }) => {
  const classes = useStyles()
  const isCurrentUserOwner = useSelector(getIsCurrentUserOwner)

  const {
    sharedContentLinkResponse,
    getSharedContentLinkLoading,
    generateContentSharedLinkMutation,
    regenerateContentSharedLinkMutation,
    revokeContentSharedLinkMutation,
    introduceContentSharedLinkMutation,
    mutationLoading,
  } = useSharedContentLinks(open && isCurrentUserOwner)
  const sharedContentLinkProps = useMemo(
    () => ({
      sharedContentLinkResponse,
      getSharedContentLinkLoading,
      generateContentSharedLinkMutation,
      regenerateContentSharedLinkMutation,
      revokeContentSharedLinkMutation,
      introduceContentSharedLinkMutation,
      mutationLoading,
    }),
    [
      generateContentSharedLinkMutation,
      getSharedContentLinkLoading,
      introduceContentSharedLinkMutation,
      mutationLoading,
      regenerateContentSharedLinkMutation,
      revokeContentSharedLinkMutation,
      sharedContentLinkResponse,
    ]
  )

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      {(mutationLoading || getSharedContentLinkLoading) && <LinearProgress />}
      <DialogTitle className={classes.header} disableTypography>
        <Typography className={classes.title} color='textSecondary' variant='h6' noWrap>
          Session settings
        </Typography>
        <Tooltip title='Close'>
          <IconButton onClick={onClose} aria-label='Close'>
            <Close />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent>
        <VideoBridgeRegions />
        <MuteChatNotifications />
        {isCurrentUserOwner && <SharedContentLinkSettings {...sharedContentLinkProps} />}
      </DialogContent>
    </Dialog>
  )
}

SessionSettingsDialog.defaultProps = {
  open: false,
  onClose: () => {},
}

SessionSettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default memo(SessionSettingsDialog)
